import clsx from 'clsx'

import { Rule } from '@/components/core-v2'

import { GroupedTab, GroupedTabsPanel } from './grouped-tabs-panel'
import { OrdersAccordionList } from './orders-accordion-list'
import classes from './orders-details-template.module.scss'
import { Order, Orders, OrderType } from './orders-types'

interface OrdersDetailsTemplateProps {
  getTabs: (
    order: Order,
    type: OrderType
  ) => [GroupedTab, GroupedTab] | [GroupedTab, GroupedTab, GroupedTab]
  isLoading: boolean
  orders: Orders
  type: OrderType
}

export const OrdersDetailsTemplate = ({
  getTabs,
  isLoading,
  orders,
  type
}: OrdersDetailsTemplateProps) => (
  <OrdersAccordionList
    isLoading={isLoading}
    orders={orders}
    renderOrder={(order: Order) => (
      <div key={`order-details-${order.orderId}`}>
        <Rule className={clsx(classes.ruleLine, 'my-3', 'mx-5')} />
        <GroupedTabsPanel label={`${type}-order-details`} tabs={getTabs(order, type)} />
      </div>
    )}
    type={type}
  />
)
